module.exports = require("./fr-VU");